import script from "./EmailInputItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInputItem.vue?vue&type=script&setup=true&lang=js"

import "./EmailInputItem.vue?vue&type=style&index=0&id=4429d3e0&lang=less"

const __exports__ = script;

export default __exports__